export default [
  {
    path: '/contratacoes',
    name: 'Contratacoes',
    alias: '',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Contratacoes',
      crud: {
        pageTitle: 'app.contratacoes.pageTitle',
        btnText: 'app.contratacoes.add',
        pageContent: () => import('App/contratacoes/ContratacoesCrudList.vue'),
        filterDialogComponent: () => import('App/contratacoes/ContratacoesFilter.vue'),
        filterComponent: () => import('Support/components/crud/OnlySearchFilter.vue'),
        anyComponent: () => import('App/contratacoes/ContratacoesTerminatteButton.vue'),
        anyComponent1: () => import('App/contratacoes/components/ContratacoesTotalList.vue'),
      },
    },
  },
];
